import { PhonePlusSolidV6 } from "@shared/v2/Icomoon";

interface TrackingNumberBadge {
  trackingName?: string;
  trackingNumber?: string;
}

const TrackingNumberBadge = ({ trackingName = "Unknown tracking name", trackingNumber = "Unknown number" }: TrackingNumberBadge) => {
  return (
    <div className="tw-border-1px tw-border-solid tw-border-gray-10 tw-rounded-4px tw-p-8px tw-text-12d tw-text-gray-75 tw-w-max tw-max-w-full tw-flex tw-items-center tw-gap-6px tw-bg-white">
      <PhonePlusSolidV6/>
      <span className='tw-truncate'>{trackingName} {trackingNumber}</span>
    </div>
  )
}; 

export default TrackingNumberBadge;


